import { render, staticRenderFns } from "./DictionaryManagement.vue?vue&type=template&id=339f0eab&scoped=true&"
import script from "./DictionaryManagement.vue?vue&type=script&lang=js&"
export * from "./DictionaryManagement.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryManagement.vue?vue&type=style&index=0&id=339f0eab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339f0eab",
  null
  
)

export default component.exports